var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('a-icon',{style:({fontSize: '60px', marginBottom: '1rem', color: '#87d068'}),attrs:{"type":"check-circle"}}),_c('p',[_vm._v("Incident pris en charge.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }